import {instanceAxios} from "@/axios/axios";

export default function postPaymentMethod(data) {
    return new Promise((resolve, reject) => {
        instanceAxios.post('Payment', data)
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                return reject(error)
            })
    })
}